<template>
  <div class="map_container col-12">
    <div class="input_wrapper">
      <input
        class="map_search_input"
        ref="searchTextField2"
        type="text"
        :placeholder="$t('FORMS.Placeholders.searchOnMap')"
        @input="getAddress"
      />
    </div>
    <div class="page_map_wrapper">
      <GMap
        ref="gMap"
        class="google_map"
        :center="mapCenter"
        :options="{}"
        :zoom="13"
        @click="generate"
      >
        <GMapMarker
          :position="marker"
          :options="{ draggable: true }"
          @mouseout="getMarker"
        ></GMapMarker>
        <!-- <GMapMarker
          v-for="(marker, index) in markers"
          :key="index"
          :position="marker"
          :options="{ draggable: true }"
          @drag="markerdraged(index, $event)"
          @click="removeMarker(index)"
        ></GMapMarker> -->
      </GMap>
    </div>
  </div>
</template>

<script>
export default {
  //   async asyncData({ $axiosRequest }) {
  //     try {
  //       const contactData = await $axiosRequest({
  //         method: 'GET',
  //         url: 'contact',
  //       })
  //       return {
  //         mapCenter: {
  //           lat: parseFloat(contactData.data.data.lat),
  //           lng: parseFloat(contactData.data.data.lng),
  //         },
  //       }
  //     } catch (err) {
  //       console.log(err.response.data.message)
  //     }
  //   },
  data() {
    return {
      // Start:: Loader Contrle Data
      isWaitingRequest: false,
      // End:: Loader Contrle Data
      isLoading: true,
      // Start:: G-map Data
      mapStyle: [
        {
          featureType: "all",
          elementType: "all",
          stylers: [{ saturation: -100 }],
        },
      ],
      // End:: G-map Data

      // Start:: Request Data
      value: "",
      address: "",
      center: null,
      mapCenter: this.location || { lat: 30.033333, lng: 31.233334 },
      marker: this.location || { lat: 30.033333, lng: 31.233334 },
      // End:: Request Data
    };
  },
  watch: {
    mapCenter() {
      if (this.$refs.gMap.map) {
        this.$refs.gMap.map.setCenter(this.mapCenter);
        this.$refs.gMap.markers[0].setPosition(this.mapCenter);
      }
      //   //   this.$refs.gMarker.map.setPosition(this.mapCenter)
    },
    marker(value) {
      if (this.$refs.gMap.map && value) {
        this.$refs.gMap.markers[0].setPosition(value);
        this.$emit("get-loaction", value);
      }
    },
  },
  props: {
    location: {
      required: false,
      type: Object,
    },
  },
  emits: ["get-loaction"],
  methods: {
    getAddress() {
      // console.log(this.value)
      var self = this;
      var input = this.$refs.searchTextField2; // var searchBox = new google.maps.places.Autocomplete(input)
      var searchBox = new google.maps.places.SearchBox(input);
      searchBox.addListener("places_changed", function () {
        var places = searchBox.getPlaces();
        if (places.length == 0) {
          return;
        }
        var bounds = new google.maps.LatLngBounds();
        places.forEach(function (place) {
          bounds.extend(place.geometry.location);
          // place.geometry.location.lng()
          // place.geometry.location.lat()
          place.formatted_address;
          self.marker = self.mapCenter = {
            lng: place.geometry.location.lng(),
            lat: place.geometry.location.lat(),
          };
          // console.log(self.mapCenter)
        });
      });
    },
    getMarker(e) {
      // console.log(e.event.latLng.lat(), e.event.latLng.lng())

      this.marker = {
        lat: e.event.latLng.lat(),
        lng: e.event.latLng.lng(),
      };
    },

    // getAddress1(e) {
    //   console.log('map' + e)
    // },
    generate(e) {
      let marker = { lat: e.event.latLng.lat(), lng: e.event.latLng.lng() };
      // console.log('mark')
      // console.log(marker)
      this.marker = {
        ...marker,
      };

      //   this.markers.push(marker)
      //   this.markers = [...this.markers]

      //   console.log(this.markers)
      // this.path.push(marker);
    },
    // removeMarker(index) {
    //   this.markers.splice(index, 1)
    //   this.$emit('markersChanged', {
    //     markers: this.markers,
    //     mapCenter: this.mapCenter,
    //   })
    // },

    // markerdraged(index, e) {
    //   let marker = { lat: e.latLng.lat(), lng: e.latLng.lng() }

    //   this.center = {
    //     ...marker,
    //   }

    //   this.$set(this.markers, index, marker)
    //   this.$set(this.path, index, marker)

    //   this.$emit('markersChanged', {
    //     markers: this.markers,
    //     mapCenter: this.mapCenter,
    //   })
    // },
    getLocation() {
      console.log("smth" + this.location);
      if (navigator.geolocation && !this.location) {
        navigator.geolocation.getCurrentPosition((position) => {
          // this.axios({
          //   method: "get",
          //   url: `https://maps.googleapis.com/maps/api/geocode/json?latlng=${position.coords.latitude},${position.coords.longitude}&key=AIzaSyAITrPfT5r_qmCm_8ekZyPmnebGo8o_r18`,
          // })
          //   .then((res) => {
          //     console.log(res.data.results[0].formatted_address);
          //   })
          //   .catch(() => {});
          // console.log('cds')
          // console.log(position)

          this.marker = this.mapCenter = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          };

          //     (this.center = this.markers[0].position)
          //   this.coordinates_to_edit.lat = this.center.lat
          //   this.coordinates_to_edit.lng = this.center.lng
        });
      }
    },
  },
  mounted() {
    this.getLocation();
  },
  created() {
    // const success = (position) => {
    //   const latitude = position.coords.latitude
    //   const longitude = position.coords.longitude
    //   // Do something with the position
    //   console.log(latitude, longitude)
    // }
    // const error = (err) => {
    //   console.log(error)
    // }
    // // This will open permission popup
    // navigator.geolocation.getCurrentPosition(success, error)
  },
};
</script>
<style lang="scss" scoped>
// Start Map  Styling
.map_container {
  margin-bottom: 1rem;
}
.map_search_input {
  width: 100%;
  margin: 0;
  outline: none;
  border-radius: 4px;
  background: #fff;
  font-size: 14px;
  margin-block-end: 8px;
  // font-family: $semi_bold_font;
  border: 1px solid var(--mainColor-2);
  line-height: 40px;
  padding-inline-start: 15px !important;
}
.page_map_wrapper {
  border-radius: 10px;
  overflow: hidden;
  height: 300px;
}
// Start Map  Styling
</style>
<style lang="scss">
.page_map_wrapper {
  .GMap__Wrapper {
    height: 300px !important;
  }
}
</style>
